export interface TblSolicitudAyud {
    esadhonorem: string;
    idperiodo: number;
    tipo: string;
    ultimocambio: Date;
    estado: string;
    fechainiautoriza?: Date; // Campo opcional debido al tipo `DateTime?`
    nombrebanco: string;
    limitehoraayud: number;
    fechareemplazo?: Date; // Campo opcional debido al tipo `DateTime?`
    codestudiante: string;
    idestudianter?: number; // Campo opcional debido al tipo `int?`
    idsolicitudayud: number;
    idestudiante: number;
    observacion: string;
    fechasolicitud?: Date; // Campo opcional debido al tipo `DateTime?`
    fechafinautoriza?: Date; // Campo opcional debido al tipo `DateTime?`
    numctabancaria: string;
    codestudianter: string;
  }

  export function VoidTblSolicitudAyud(): TblSolicitudAyud {
    return {
      esadhonorem: '',
      idperiodo: 0,
      tipo: '',
      ultimocambio: new Date(0), // Fecha predeterminada (01/01/1970)
      estado: '',
      fechainiautoriza: undefined, // Campo opcional
      nombrebanco: '',
      limitehoraayud: 0,
      fechareemplazo: undefined, // Campo opcional
      codestudiante: '',
      idestudianter: undefined, // Campo opcional
      idsolicitudayud: 0,
      idestudiante: 0,
      observacion: '',
      fechasolicitud: undefined, // Campo opcional
      fechafinautoriza: undefined, // Campo opcional
      numctabancaria: '',
      codestudianter: ''
    };
  }
  